import React from 'react';

const NotEnoughDataMessage = () => {
  return <div className='graph-warning-message'>Not enough data is available.</div>;
};

export default NotEnoughDataMessage;
